import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import {
	useRenderEmail
} from 'shared/apollo';

const MessagePreviewPopup = ({ id, open, onClose }) => {
  const { run } = useRenderEmail();
  const [ data, setData ] = useState({
    subject: 'Loading...',
    body: '...'
  });

  useEffect(() => {
    run({id}, (resp) => {
      setData(resp);
    });
  }, []) // eslint-disable-line

  return (
    <DialogRoot onClose={onClose} open={open} maxWidth='md' fullWidth>
      <DialogTitle onClose={onClose}>
        Message Sent
        <CloseIcon className="close" onClick={onClose}/>
      </DialogTitle>
      <DialogContent dividers>
        <PreviewContainer>
          <p class="small">Subject</p>
          <p>{data.subject}</p>
        </PreviewContainer>
        <PreviewContainer>
          <p>
            <div dangerouslySetInnerHTML={{ __html: data.body }} />
          </p>
        </PreviewContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" startIcon={<DoneIcon />}>Done</Button>
      </DialogActions>
    </DialogRoot>
  );
};

const DialogRoot = styled(Dialog)`
  div.MuiDialogTitle-root {
    background-color: #ebf0f6;
    color: #48596B;
    font-weight: 400;
    font-size: 16px;
  }
  div.MuiInputBase-root {
    min-height: 50px;
  }
  p {
    color: rgb(72, 89, 107);
    font-size: 16px;
    font-weight: 700;
    &.mt20 {
      margin-top: 20px;
    }
    span {
      font-size: 15px;
      font-weight: 400;
    }
  }
  svg.close {
    color: rgb(72, 89, 107);
    float: right;
    font-size: 25px;
    transform: translateY(5px);
  }
  button {
    min-height: 48px;
    padding-left: 25px;
    padding-right: 25px;
    text-transform: none;
    &.floatLeft {
      position: absolute;
      left: 16px;
    }
  }
  .MuiChip-clickable {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .MuiChip-root.error {
    margin-top: 16px;
    color: #ff4d4f;
    border: solid 1px #ff4d4f;
    svg {
      color: #ff4d4f;
    }
  }
  .MuiChip-root.success {
    margin-top: 16px;
  }
`;

const PreviewContainer = styled.div`
  width: 100%;
  height: auto;
  background-color: #ebf0f6;
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
  p {
    color: rgb(72, 89, 107);
    font-size: 17px;
    font-weight: 400;
    &.small {
      font-size: 14px;
      font-weight: 700;
    }
  }
`;

export default MessagePreviewPopup;